"use client";

/** Visible progress state while a Marketplace product is checked against the
 *  intake. The surrounding flow owns whether its Continue action is gated. */

export interface ProductFitCheckingProps {
  productName: string;
}

export function ProductFitChecking({ productName }: ProductFitCheckingProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="mx-[15px] mb-[13px] flex gap-2.5 rounded-(--radius-field) border border-(--border-default) bg-(--bg-canvas) px-[13px] py-[11px] font-[family-name:var(--font-body)]"
    >
      <span
        aria-hidden="true"
        className="mt-0.5 h-[15px] w-[15px] shrink-0 animate-spin rounded-full border-2 border-(--border-default) border-t-(--fg-brand)"
      />
      <div className="min-w-0 flex-1">
        <p className="text-[13px] font-semibold text-(--fg-primary)">
          Checking product fit…
        </p>
        <p className="mt-1 text-[12.5px] leading-[1.45] text-(--fg-secondary)">
          Comparing {productName} with your intake.
        </p>
      </div>
    </div>
  );
}
